// extracted by mini-css-extract-plugin
module.exports = {"buttonGroup":"ButtonGroup_buttonGroup__1W1c2","primary":"ButtonGroup_primary__3JqDs","secondary":"ButtonGroup_secondary__3jnIA"};